import { useEffect, useState } from 'react';

import { FormikErrors, FormikValues } from 'formik';

interface IUseCollapsibleFormSection {
  fieldNames: string[];
  errors: FormikErrors<FormikValues>;
  submitCount: number;
}

const useCollapsibleFormSection = ({
  fieldNames,
  errors,
  submitCount,
}: IUseCollapsibleFormSection) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const hasSectionErrors = fieldNames.some((fieldName) =>
    Boolean(errors[fieldName]));

  // A collapsed section would hide its validation errors, so reveal it after a failed submit.
  useEffect(() => {
    if (submitCount > 0 && hasSectionErrors) {
      setIsExpanded(true);
    }
  }, [submitCount, hasSectionErrors]);

  const handleToggle = () => {
    setIsExpanded((prev) =>
      !prev);
  };

  return { isExpanded, handleToggle };
};

export default useCollapsibleFormSection;
